//#region imports
import React, {useEffect, useState, useRef} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, TableNumber, RequestHeader, HttpRequest, List } from '../../components/molecules';
import { IntegrationRow } from '../../components/organisms'

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
  
// images
import BookingCard from '../../assets/images/home/booking-card.png';

// swagger
import SwaggerUI from "swagger-ui-react";

// code block
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import CreatedPRMBooking from '../../assets/images/creating-booking/created-booking-with-customer.png';

//#endregion

const CreateBooking = (props) => {

    // control tab
    const [tab, setTab] = useState(1)

    const border = false; 
    const ssrRef = useRef(null)
    const executeScroll = () => ssrRef.current.scrollIntoView()    

    //#region custom components 

    // text components used in tables
    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    // passenger information table
    const PassengerInformationTable = () => {
        
        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.description}</TextText></td>
                <td><TextText>{props.example}</TextText></td>
                <td><TextText>{props.required}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead>
                            <tr style={{}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE}} scope="col">Description</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE}} scope="col">Example</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE}} scope="col">Required</th>
                            </tr>
                        </thead>
                    <tbody>
                        <Row data={'Title'} description={'Passenger title'} example={'MR'} required={'Optional'} />
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Joe Bloggs'} required={'Yes'} />
                        <Row data={'Reference Number'} description={'Reference number given to passenger by airline (PNR)'} example={'JWRTY5'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ WCHR, WCHS]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'True'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    // example booking table
    const ExampleBooking = (props) => {
        
        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Title</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Name</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Reference</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Origin</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Destination</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Flight</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Departure</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Assistance</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Equipment</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Service Animal</th>
                            </tr>
                        </thead>
                    <tbody>
                        <tr><td><TextText>MR</TextText></td><td><TextText>Joe Bloggs</TextText></td><td><TextText>JWRT76</TextText></td><td><TextText>DUB</TextText></td><td><TextText>JFK</TextText></td><td><TextText>EI105</TextText></td><td><TextText>07-12-2022</TextText></td><td><TextText>['WCHS', 'BLND']</TextText></td><td><TextText>False</TextText></td><td><TextText>False</TextText></td></tr>
                    </tbody>
                </table>
            </div>
        )
    }

    // ssr code table
    const CodesTable = (props) => {
        
        const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
        const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

        const Row = (props) => { return (
            <tr>
                <td><Text.TableHeader bold={true}>{props.code}</Text.TableHeader></td>
                <td><Text.TableBody>{props.description}</Text.TableBody></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader bold={true}>SSR Code</Text.TableHeader></th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader bold={true}>Description</Text.TableHeader></th>
                            </tr>
                        </thead>
                    <tbody>
                        <Row code={'WCHR'} description={'Wheelchair - R for Ramp (Passenger can ascend/descend steps and make own way to/from cabin seat but requires wheelchair for distance to/from aircraft)'} />
                        <Row code={'WCHS'} description={'Wheelchair - S for Stairs (Passenger cannot ascend/descend steps, but is able to make own way to/from cabin seat)'} />
                        <Row code={'WCHC'} description={'Wheelchair - C for Cabin (Passenger totally immobile)'} />
                        <Row code={'WCMP'} description={'Wheelchair - Manual power'} />
                        <Row code={'WCOB'} description={'On-board Wheelchair (provided by airline)'} />
                        <Row code={'WCBD'} description={'Wheelchair - Non-spillable battery'} />
                        <Row code={'WCBW'} description={'Wheelchair - Wet cell battery'} />
                        <Row code={'MAAS'} description={'Meet and assist'} />
                        <Row code={'BLND'} description={'Blind or visually impaired passenger'} />
                        <Row code={'DPNA'} description={'Disabled passenger with intellectual or developmental disability needing assistance'} />
                        <Row code={'ESAN'} description={'Passenger with Emotional Support/Psychiatric Assistance Animal in Cabin'} />
                        <Row code={'POXY'} description={'Passenger Own Oxygen'} />
                        <Row code={'PETC'} description={'Animal in Cabin'} />
                        <Row code={'PPOC'} description={'Personal Portable Oxygen Concentrator'} />
                        <Row code={'STCR'} description={'Stretcher Passenger'} />
                        <Row code={'SVAN'} description={'Passenger with Service Animal in Cabin'} />
                        <Row code={'AOXY'} description={'Airline Supplied Oxygen'} />
                        <Row code={'MEQT'} description={'Medical Equipment'} />
                        <Row code={'DEAF'} description={'Deaf or hearing impaired Passenger'} />
                    </tbody>
                </table>
            </div>
        )
    }

    // example of booking
    const ExampleBookingTable = (props) => {

        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.example}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <p>Passenger and Booking Information</p> 
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Value</th>
                            </tr>
                        </thead>
                    <tbody>
                        <Row data={'Title'} description={'The title of the passenger'} example={'Mr.'} required={'Optional'} />
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Joe Bloggs'} required={'Yes'} />
                        <Row data={'Reference Number'} description={'The reference number of the booking. (PNR)'} example={'JWTR67'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ Wheelchair Access, Impaired Eyesight]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'False'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    // request headers for post request
    const RequestHeaders = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Parameter</th>
                            <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>Authorization</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Includes your API key and API secret e.g <API_KEY>:<API_SECRET>'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>Content-type</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>application/json</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    // post booking 
    const HttpRequestBar = (props) => {
        return (
            <div style={{borderWidth:1, borderStyle:'solid', borderColor:'#449A79', display:'flex', borderRadius:5, backgroundColor:'#EDF7F4', cursor:'pointer', marginBottom:22}}>
                <div style={{
                    backgroundColor:'#449A79',
                    marginTop:12,
                    marginLeft:12,
                    marginRight:12,
                    marginBottom:12,
                    borderRadius:5
                }}>
                    <p
                        style={{
                            fontWeight:'700',
                            color:Colors.PRM_LIGHT_BLUE,
                            fontSize:18,
                            textAlign:'center',
                            marginTop:12,
                            paddingLeft:22,
                            paddingRight:22
                        }}
                    >POST</p>
                </div>
                <p style={{
                    fontWeight:'bold',
                    fontSize:22,
                    marginTop:20
                }}>https://connect.prmassist.com/api/v1/bookings</p>
            </div>
        )
    }

    const RequestBody = (props) => {

        const TableRow = (props) => {
            return (
                <tr>
                    <td scope="col"><Text.TableHeader bold={props.bold} margin={props.margin}>{props.parameter}</Text.TableHeader></td>
                    <td scope="col"><Text.TableHeader>{props.type}</Text.TableHeader></td>
                    <td scope="col"><Text.TableBody>{props.description}</Text.TableBody></td>
                </tr>
            )
        }

        return (
            <table class="table" style={{ }}>
                <thead>
                    <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader>Parameter</Text.TableHeader></th>
                    <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader>Type</Text.TableHeader></th>
                    <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                </thead>
                <tbody>
                    <TableRow bold={true} parameter={'title (optional)'} type={'String'} description={'The title of the passenger'} />
                    <TableRow bold={true} parameter={'name (optional)'} type={'String'} description={'The name of the passenger. Can be left empty in which case a UUID is generated'} />
                    <TableRow bold={true} parameter={'referenceNumber'} type={'String'} description={'The reference number of the booking given to the passenger by the airline'} />
                    <TableRow bold={true} parameter={'flightDetails'}   type={''} description={'Object describing the details of the passengers flight'} />
                    <TableRow parameter={'origin'} type={'String'} description={'The ICAO code of the origin airport'} margin={true} />
                    <TableRow parameter={'destination'} type={'String'} description={'The ICAO code of the destination airport'} margin={true} />
                    <TableRow parameter={'carrierCode'} type={'String'} description={'The carrier code of the flight'} margin={true} />
                    <TableRow parameter={'flightNumber'} type={'String'} description={'The flight number of the flight'} margin={true} />
                    <TableRow parameter={'departureDate'} type={'String'} description={'The departure date of the flight'} margin={true} />
                    <tr>
                        <td scope="col"><Text.TableHeader bold={true} margin={props.margin}>{'assistance'}</Text.TableHeader></td>
                        <td scope="col"><Text.TableHeader>{'String[]'}</Text.TableHeader></td>
                        <td scope="col" style={{display:'flex'}}><Text.TableBody>{'An array of '}</Text.TableBody><p onClick={executeScroll} style={{color:'blue', cursor:'pointer', textDecoration:'underline', marginLeft:4, fontSize:14}}>SSR Codes</p></td>
                    </tr>
                    <TableRow bold={true} parameter={'equipmentInformation (optional)'} type={'String'} description={'Object describing the details of a passengers wheelchair'} />
                    <TableRow parameter={'make'} type={'String'} description={'The make of the wheelchair'} margin={true} />
                    <TableRow parameter={'model'} type={'String'} description={'The model of the wheelchair'} margin={true} />
                    <TableRow parameter={'weight'} type={'Number'} description={'The weight of the wheelchair (kg)'} margin={true} />
                    <TableRow parameter={'battery'} type={'String'} description={'Battery type of the equipment'} margin={true} />
                    <TableRow parameter={'deviceType'} type={'String'} description={'Type of wheelchair eg. Powered Wheelchair'} margin={true} />
                    <TableRow parameter={'numberOfBatteries'} type={'Int'} description={'Number of batteries on wheelchair'} margin={true} />
                    <TableRow parameter={'devicePowered'} type={'Boolean'} description={'Describes if wheelchair uses manual or other battery types'} margin={true} />
                    <TableRow parameter={'batteryWattHours'} type={'Float'} description={'Battery Wattage'} margin={true} />
                    <TableRow parameter={'selectDeviceTypeNonPowered'} type={'Boolean'} description={'Wheelchair Type eg. Mannual Wheelchair'} margin={true} />
                    <TableRow bold={true} parameter={'dimensions'} type={''} description={'Object describing the details of the wheelchair dimensions'} />
                    <TableRow parameter={'width'} type={'Number'} description={'Width of the wheelchair (cm)'} margin={true} />
                    <TableRow parameter={'height'} type={'Number'} description={'Height of the wheelchair (cm)'} margin={true} />
                    <TableRow parameter={'depth'} type={'Number'} description={'Depth of the wheelchair (cm)'} margin={true} />
                    <TableRow bold={true} parameter={'serviceAnimal'} type={'Boolean'} description={'Wether or not the passenger is accompanied by a service animal'} />
                </tbody>
            </table>
        )
    }

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:Colors.PRM_LIGHT_BLUE }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>201 Created</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the bookings have been successfully created. The response contains a list of the ids of the bookings returned in the order that they were sent'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was a mistake in forming the JSON object. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    //#endregion

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'POST Request'}
                        title={'Create a PRM Booking'}
                        subtitle={'Use this guide to learn how to create PRM bookings and post them to our database.'}
                        prerequisites={[
                            'JSON Web Token',
                            'Passenger Information',
                            'Passenger Booking Information'
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview Authentication */}
            <Row>
                <Col >
                            
                    {/* Overview */}
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`A PRM Booking is a booking request made by a passenger to order their assistance for their transit.
                     This booking request contains important information that will help the airport and airline handle the booking. A PRM Booking can be created by several methods: PRM Assist App, PRM Portal and Airline.`}</Text.Text>
                    <img
                        src={BookingCard}
                        width='350px'
                        alt=""
                    />
                </Col>
            </Row>

            {/* Section Tab Selector */}
            <Col >
                <TabList 
                    tabs={['Overview', 'Examples', 'Implementation', 'Integration']}
                    setTab={(value)=>{ setTab(value)}}
                />
            </Col>

            {/* Overview 1. Authorization */}
            { tab == 1 && 
            <>
            <Row className='mt-4' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                <Col >
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token, generated from a Client ID and Client Secret and using the authentication endpoint discussed in the Authentication Section.'}</Text.Text>
                    </Container>
                </Col>
            </Row>
             
            
            <Row className='mt-3' style={{borderWidth:border && 1, borderStyle: border && 'solid' }}>
                <Col >
                    <Container>
                        <Text.Subheading>2. Booking Information</Text.Subheading>
                        <Text.Text>{'Each booking in the PRM Assist Database is made up of two parts:'} </Text.Text>
                        <Container>    
                            <ul>
                                <li><Text.Text>{'Passenger Information'}</Text.Text></li>
                                <li><Text.Text>{'Flight Information'}</Text.Text></li>
                            </ul>
                        </Container>
                    </Container>
                </Col>
            </Row>
            
            <Row>
                <Col >
                    <Container className='mt-2'>
                        <TableNumber 
                            title={'Table 1.1 - Example Information'}
                            description={'The table below shows an example of personal and flight information for a passenger.'}
                        />
                        <PassengerInformationTable />
                    </Container>

                    <Container className='mt-5'>
                        <TableNumber 
                            title={'Table 1.2 - Example Booking'}
                            description={'The table below shows an example of a booking.'}
                        />
                        <ExampleBooking />
                        
                    </Container>
                </Col>
            </Row>
            
            <Row className='mt-5'>
                <Col >
                    <Container>
                        <Text.Subheading>3. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Create Booking API with a detailed API structure, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>
                    </Container>
                </Col>
            </Row>
            

            {/* Overview 3.1 - Header Table */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>3.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader contentType={true} />
                    </Container>
                </Col>
            </Row>

            {/* Overview 3.2 - Request Body */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <Text.Subheading>3.2 Body</Text.Subheading>
                        <Text.Text>{'The request body contains the PRM Booking in JSON format. For posting a single booking, it is a single JSON object contained within a JSON array:'}</Text.Text>
                        <RequestBody />
                    </Container>
                </Col>
            </Row>

            {/* Overview 3.3 - Response */}
            <Row className='mt-5'>
                <Col >
                    <Container>
                        <Text.Subheading>3.3 Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
                
            {/* Extra */}
            <Row className='mt-2'>
                <Col >
                    <Container>
                        <div ref={ssrRef}>
                        <Text.Subheading>4. Extra</Text.Subheading>
                        <Text.Text>{'This section contains supplementary information.'}</Text.Text>
                        <p>Table 4.1 - SSR Codes</p>
                        <Text.Text>{'The table below shows the possible SSR Codes attached to a booking.'}</Text.Text>
                        <CodesTable />
                        </div>
                    </Container>
                </Col>
            </Row>
            </>
            }
            
            {/* Example */}
            { tab === 2 &&
            <>
                {/* Example Request w/ request body */}
                <Row className='mt-4'>
                    <Col >
                        <Container>

                            {/* Text */}
                            <Text.Subheading>1. Example Requests</Text.Subheading>
                            <Text.Text>{'This section contains examples of converting a passenger booking into a posted booking request.'}</Text.Text>

                            <Text.Subsubheading>1.1 Posting a single booking</Text.Subsubheading>
                            <Text.Text>{'In this example we post a single booking for a passenger, Joe Bloggs, who is flying from Dublin to Manchester. The flight route is chartered by Aer Lingus and the passenger requires wheelchair equipment. The passenger is not accompanied by a service animal.'}</Text.Text>
                            
                            <Text.Subsubheading>1.1.1 Request</Text.Subsubheading>
                            <HttpRequest 
                                requestType={'POST'}
                                url={'https://connect.prmassist.com/api/v1/booking'}
                                headers={['Authorization: Bearer <token>', 'Content-Type: [application/json]']}
                            />

                            {/* Table and Codeblock */}
                            <Row className='mt-5'>
                                <Col>
                                    <ExampleBookingTable />
                                </Col>
                                <Col>
                                    <p>Request Body</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['json']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            
                {/* Example Response */}
                <Row className='mt-5'>
                    <Col >
                        <Container>
                            
                            {/* Text */}
                            <Text.Subsubheading>1.1.2 Response</Text.Subsubheading>
                            <Text.Text>The response is the booking's unique identifier, which can be used to access this booking via PRM Connect's other endpoints. In the case where two people with the same name are present on the same flight, a number is attached to the end of the identifier to maintain uniqueness. </Text.Text>
                            
                            {/* Code block */}
                            <Row>
                                <Col xs={6} />
                                <Col>
                                    <p>Response from Request</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['response2']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>

                        </Container>
                    </Col>
                </Row>
                
                {/* Example Request w/ request body */}
                <Row className='mt-4'>
                    <Col >
                        <Container>

                            <Text.Subsubheading>1.2 Posting a duplicate booking</Text.Subsubheading>
                            <Text.Text>{'In this example we post a single booking for a passenger, Joe Bloggs, who is flying from Dublin to Manchester. We then post the same booking again, with changed assistance request information to examine the response of the API.'}</Text.Text>
                            
                            {/* Table and Codeblock */}
                            <Row className='mt-5'>
                                <Col>
                                    <p>Inital POST Request Body</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['json']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                                <Col>
                                    <p>Duplicate POST Request Body</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['jsonDuplicate']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>

                            <Row className='mt-5'>
                                <Text.Subsubheading>1.3 Response from duplicate booking</Text.Subsubheading>
                                <Text.Text>{'The first request will create the booking, because the second POST request contains the same flight information and passenger information the API will update the previous booking with any changed information ( Assistance or Equipment Information)'}</Text.Text>
                            </Row>

                            {/* Code block */}
                            <Row>
                                <Col>
                                    <p>Response Inital POST</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['responseDuplicate']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                                <Col>
                                    <p>Response Duplicate POST</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['responseDuplicate2']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>
            
                            <Row className='mt-3'>
                                <Text.Text>{'The first number in the rev field indicates how many updates the booking has underwent. We can see that because the booking was updated with the second post request the rev field starts with a 2'}</Text.Text>
                            </Row>

                        </Container>
                    </Col>
                </Row>
            
                {/* Multiple Bookings */}
                <Row className='mt-5'>
                    <Col className='mt-3'>
                        <Container>

                            {/* Title */}
                            <Text.Subsubheading>1.2 Posting multiple bookings</Text.Subsubheading>
                            <Text.Text>{'This next example shows how to post multiple bookings. The first booking is the "Joe Bloggs" example from above, and the second is an anonymous booking (the name has been left out), for flight EI105 from Dublin to JFK, requiring Meet-and-Assist assistance and DPNA assistance, and they have not brought a wheelchair. '}</Text.Text>

                            {/* Request Information */}
                            <HttpRequest 
                                requestType={'POST'}
                                url={'https://connect.prmassist.com/api/v1/booking'}
                                headers={['Authorization: Bearer <token>', 'Content-Type: [application/json]']}
                            />


                            {/* Table and Codeblock */}
                            <Row className='mt-5'>
                                <Col>
                                    <ExampleBookingTable />
                                </Col>
                                <Col>
                                    <p>Request Body</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['json']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>

                            {/* Response */}
                            <Row className={'mt-5'}>

                                {/* Title */}
                                <Text.Subsubheading>1.1.2 Response</Text.Subsubheading>
                                <Text.Text>The response is the booking's unique identifier, which can be used to access this booking via PRM Connect's other endpoints. In the case where two people with the same name are present on the same flight, a number is attached to the end of the identifier to maintain uniqueness. In this example we post a single booking for a passenger, Joe Bloggs, who is flying from Dublin to Manchester. The flight route is chartered by Aer Lingus and the passenger requires wheelchair equipment. The passenger is not accompanied by a service animal.</Text.Text>
                                
                                {/* Code block */}
                                <Col xs={6} /> 
                                <Col>
                                    <p>Response from Multiple Booking Request</p>
                                    <CopyBlock
                                        language={'json'}
                                        text={sample['response3']}
                                        showLineNumbers={false}
                                        theme={dracula}
                                        wrapLines={false}
                                    />
                                </Col>
                            </Row>

                        </Container>
                    </Col>
                </Row>
    
            </>
            }

            {/* Request */}
            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for posting an example booking, reviewing the different responses and error codes.'}</Text.Text>

                            <SwaggerUI url="bulk_post.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Integration */}
            { tab === 4 && 
            <>
                <IntegrationRow 
                    title={'1. Creating a Booking'}
                    description={'In this section, we examine how PRM Connect works to receive bookings from a client.'}
                />

                <IntegrationRow 
                    title={'1.1 A Passenger Creates a Booking with the Airline'}
                    description={'If a passenger creates a booking with the airline, the airline should call the POST request to create the booking in the PRM Connect database.'}
                    description2={'The client sets up the POST request to act like a middleware, when a passenger creates a PRM booking with the airline this booking should then automatically post the request to PRM Connect. This removes any need for a booking to be marked as sent to PRM Assist on the client’s side because it can be assumed that all bookings that are created are immediately forwarded on.'}
                    imageTitle={<TableNumber title={'1.1 Created Airline Booking'} description={'Example of a booking stored in the airline database being created on the PRM Connect database'} />}
                    image={<img
                        src={CreatedPRMBooking}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{}}
                    />}
                />
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Authentication'} leftLink={'/authentication'}  rightText={'Polling Bookings'} rightLink={'/getting-updated-deleted'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default CreateBooking;
